

import { PropertiesService } from './properties.service';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { RisorseEdizioneResponse, RegolamentoEdizione } from '../interfaces/edition';

@Injectable({
	providedIn: "root"
})

export class EditionService {

    constructor(private httpClient: HttpClient, private propService: PropertiesService) {}

	getRisorseEdizione(): Observable<RisorseEdizioneResponse> {
        return this.httpClient.get<RisorseEdizioneResponse>(
            `${this.propService.getProp('apiPrefix')}/api/Public/Edizione/RisorseEdizione`
        );
    }

    getRegolamentoEdizione(): Observable<RegolamentoEdizione> {
		return this.httpClient.get<RegolamentoEdizione>(this.propService.getProp('apiPrefix')+'/api/Public/Edizione/RegolamentoCorrente');
	}
}